import { Button, Tooltip, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      marginLeft: "7px",
      height: 35,
      boxShadow: "none",
    },
  })
);

interface LinkButtonProps {
  tooltip: NonNullable<React.ReactNode>;
  href: string;
  target: string;
}

const LinkButton: React.FC<LinkButtonProps> = ({ children, href, target, tooltip }) => {
  const cssClasses = useStyles({});

  return (
    <Typography variant="h4">
      <Tooltip title={tooltip}>
        <Button
          className={cssClasses.root}
          variant="contained"
          size="small"
          color="primary"
          href={href}
          target={target}
        >
          {children}
        </Button>
      </Tooltip>
    </Typography>
  );
};

export default LinkButton;
